var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chat"},[_c('div',{staticClass:"chat-btns",on:{"click":_vm.handleChatClick}},[_c('img',{staticClass:"chat-icon",attrs:{"src":require("@/assets/images/help_dark.svg")}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }